//Control and number combination
export const CTRL_DIGIT1 = 'Digit1_true';
export const CTRL_NUMPAD1 = 'Numpad1_true';
export const CTRL_DIGIT2 = 'Digit2_true';
export const CTRL_NUMPAD2 = 'Numpad2_true';
export const CTRL_DIGIT3 = 'Digit3_true';
export const CTRL_NUMPAD3 = 'Numpad3_true';
export const CTRL_DIGIT4 = 'Digit4_true';
export const CTRL_NUMPAD4 = 'Numpad4_true';
export const CTRL_DIGIT5 = 'Digit5_true';
export const CTRL_NUMPAD5 = 'Numpad5_true';
export const CTRL_DIGIT6 = 'Digit6_true';
export const CTRL_NUMPAD6 = 'Numpad6_true';
export const CTRL_DIGIT7 = 'Digit7_true';
export const CTRL_NUMPAD7 = 'Numpad7_true';
export const CTRL_DIGIT8 = 'Digit8_true';
export const CTRL_NUMPAD8 = 'Numpad8_true';
export const CTRL_DIGIT9 = 'Digit9_true';
export const CTRL_NUMPAD9 = 'Numpad9_true';
export const CTRL_DIGIT0 = 'Digit0_true';
export const CTRL_NUMPAD0 = 'Numpad0_true';
export const CTRL_ALT_DIGIT1 = 'Digit1_true_true';
export const CTRL_ALT_NUMPAD1 = 'Numpad1_true_true';
export const CTRL_ALT_DIGIT2 = 'Digit2_true_true';
export const CTRL_ALT_NUMPAD2 = 'Numpad2_true_true';
export const CTRL_ALT_DIGIT3 = 'Digit3_true_true';
export const CTRL_ALT_NUMPAD3 = 'Numpad3_true_true';
export const CTRL_ALT_DIGIT0 = 'Digit0_true_true';
export const CTRL_ALT_NUMPAD0 = 'Numpad0_true_true';

export const CTRL_KEY_CODE__1 = '1_true';
export const CTRL_KEY_CODE__2 = '2_true';
export const CTRL_KEY_CODE__3 = '3_true';
export const CTRL_KEY_CODE__4 = '4_true';
export const CTRL_KEY_CODE__5 = '5_true';
export const CTRL_KEY_CODE__6 = '6_true';
export const CTRL_KEY_CODE__7 = '7_true';
export const CTRL_KEY_CODE__8 = '8_true';
export const CTRL_KEY_CODE__9 = '9_true';

//Key board button constants
export const CTRL_RIGHTARROW = 'ArrowRight_true';
export const CTRL_LEFTARROW = 'ArrowLeft_true';
export const RIGHTARROW = 'ArrowRight';
export const LEFTARROW = 'ArrowLeft';
export const ESCAPE_BUTTON = 'Escape_false';
export const ENTER_BUTTON = 'Enter_false';
export const ENTER_NUMPAD_BUTTON = 'NumpadEnter_false';
export const TAB_BUTTON = 'Tab_false';
export const SPACE_BUTTON = 'Space_false';
export const UP_ARROW_BUTTON = 'ArrowUp_false';
export const DOWN_ARROW_BUTTON = 'ArrowDown_false';

export const CTRL_KEY_CODE_RIGHTARROW = 'Right_false';
export const CTRL_KEY_CODE_LEFTARROW = 'Left_false';
export const KEY_CODE_RIGHTARROW = 'Right';
export const KEY_CODE_LEFTARROW = 'Left';
export const ESCAPE_KEY_CODE_BUTTON = 'Esc_false';
export const ENTER_KEY_CODE_BUTTON = 'Enter_false';
export const TAB_KEY_CODE_BUTTON = 'Tab_false';
export const SPACE_KEY_CODE_BUTTON = 'Spacebar_false';
export const UP_KEY_CODE_ARROW_BUTTON = 'Up_false';
export const DOWN_KEY_CODE_ARROW_BUTTON = 'Down_false';

export const CTRL_LETTERT = 'KeyT_true_true';
export const CTRL_LETTERN = 'KeyN_true_true';
export const CTRL_LETTERA = 'KeyA_true_true';
export const CTRL_LETTERR = 'KeyR_true_true';
export const CTRL_LETTERU = 'KeyU_true_true';
export const CTRL_LETTERP = 'KeyP_true_true';
export const CTRL_LETTERW = 'KeyW_true_true';
export const CTRL_LETTERC = 'KeyC_true_true';
export const CTRL_LETTERS = 'KeyS_true_true';
export const CTRL_LETTERX = 'KeyX_true_true';
export const CTRL_LETTERF = 'KeyF_true_true';
export const CTRL_LETTERE = 'KeyE_true_true';
export const CTRL_LETTERD = 'KeyD_true_true';
export const CTRL_LETTERO = 'KeyO_true_true';
export const CTRL_LETTERQ = 'KeyQ_true_true';
export const CTRL_LETTERB = 'KeyB_true_true';
export const CTRL_LETTERJ = 'KeyJ_true_true';
export const CTRL_LETTERM = 'KeyM_true_true';
export const CTRL_LETTERI = 'KeyI_true_true';
export const ALT_KEY = 'AltLeft_true';
export const CTRL_ALT_KEY = 'AltLeft_true_true';
export const ESC_KEY = 'Escape';
export const PREFERENCES = {
  dateFormat: 'MM/dd/yyyy',
  timeFormat: 'hh:mm a',
};
